const trustPilotPluginModule = {
    state: () => ({
        isActive: false,
        doSendProductInvitation: false
    }),
    mutations: {
        sendProductInvitation(state, flag) {
            state.doSendProductInvitation = flag;
        },
        active(state, flag) {
            state.isActive = flag;
        }
    },
    getters: {
        sendProductInvitation(state) {
            return state.isActive && state.doSendProductInvitation;
        },
        active(state) {
            return state.isActive;
        }
    }
};

Shopware.State.registerModule('trustpilot-state', trustPilotPluginModule);
